import { createTheme } from '@mui/material/styles';

// Define your custom colors
const lightNavy = '#1E2A4A';
const gray = '#6C757D';
const orangePink = '#FF595A';

const theme = createTheme({
  palette: {
    primary: {
      main: lightNavy,
    },
    secondary: {
      main: orangePink,
    },
    text: {
      primary: lightNavy,
      secondary: gray,
    },
    background: {
      default: '#F8F9FA', // A light background for contrast
      paper: '#FFFFFF',
    },
  },
  typography: {
    fontFamily: [
      '-apple-system',
      'BlinkMacSystemFont',
      '"Segoe UI"',
      'Roboto',
      '"Helvetica Neue"',
      'Arial',
      'sans-serif',
      '"Apple Color Emoji"',
      '"Segoe UI Emoji"',
      '"Segoe UI Symbol"',
    ].join(','),
  },
});

export default theme;